import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Button, Icon } from 'antd'
import { PageCrumbs } from 'components'
import useAxios from 'axios-hooks'
import { useProjects } from 'context/project-context'
import { getAuthHeader } from 'utils/auth'
import { notificationToast } from 'components/NotificationToast';
import {RUN_SCAN_PERMISSION, TRIAL} from 'utils/constants'; 
import ScanParametersModal from './ScanParametersModal';
import { SCAN_PARAMETERS, BASE_ADDRESS_KEY } from 'views/ScanSettings/NewScan/constants'
import {usePayment} from 'context/payment-context';

const StyledScanSettingsTop = styled.div({
	display: 'grid',
	gridTemplateColumns: '1fr 90px 152px 152px',
	marginBottom: 20,
	gridGap: 10
})

const ScansTop = ({ scanSettingsId, selectedScans, navigate, scanSettingsName, initialDisableRescan , firstScan ,fetchScans, user, scanSettings}) => {
	let abDisabled = selectedScans.length < 2 || selectedScans.length > 2
	const { project } = useProjects()
	const [rescanEnabled, setRescanEnabled] = useState(true);
	const [isParametersModalVisible, setParametersModalVisible] = useState(false);
	const [isModalLoading, setModalLoading] = useState(false);
	const {setPaymentModalOpen, isTrialAccount, isCanceledPayg} = usePayment();

	let isAllowed = user.permissions.filter((p) => RUN_SCAN_PERMISSION.includes(p));

	const [{ data, loading, error }, scan] = useAxios({
		url: `${project.name}/scan-settings/scans`,
		method: 'POST',
		headers: getAuthHeader()
	}, {manual: true})

	useEffect(() => {
		if(data) {
			navigate(`/scan-settings/${scanSettingsId}/scans`,  {
				replace: true
			})
			fetchScans({ data: { scanSettingsId } })
			setParametersModalVisible(false);
		}

		let runScanErrors = error && error.response && error.response.data && error.response.data.Errors;
		let wihtoutParameters = !scanSettings || scanSettings && !scanSettings[SCAN_PARAMETERS];
		if (runScanErrors && wihtoutParameters) {
			notificationToast({
				message: 'Error',
				description: `${runScanErrors}`,
				icontype: "alert"
			})
		}
	}, [data, error])

	const rescanClick = (scanSettingsId, rescanEnabled, baseAddress, uRemediateProfile) => { 
		if(isTrialAccount || isCanceledPayg){
			setPaymentModalOpen(true, "rescan");
			return;
		}

		if(!rescanEnabled) return;

		setTimeout(() => {
			setRescanEnabled(true);
		}, 3000); 
		setRescanEnabled(false); 

		var data = {scan_settings_id: scanSettingsId}

		if(baseAddress){
			data.parameters = {[BASE_ADDRESS_KEY]: baseAddress}
		}

		if(uRemediateProfile){
			if(data.parameters){
				data.parameters["disable_uremediate_profiles"] = uRemediateProfile;
			}
			else{
				data.parameters = {"disable_uremediate_profiles": uRemediateProfile}
			}
		}
		
		scan({data});
	}

	return (
		<StyledScanSettingsTop>
			<PageCrumbs
				crumbs={[
					{ name: 'Scan Settings', icon: 'bars', path: '/scan-settings' },
					{ name: scanSettingsName }
				]}
			/>
			<Button type="primary" onClick={() => navigate('../../')}>
				<Icon type="left" />
				BACK
			</Button>
			<Button
				id="compare"
				type="primary"
				icon="block"
				onClick={() => navigate(`../../${scanSettingsId}/scan-compare/${selectedScans[0]}/${selectedScans[1]}`)}
				disabled={abDisabled}
			>
				A/B COMPARE
			</Button>
			{ !scanSettings || scanSettings && !scanSettings[SCAN_PARAMETERS]
				?
					<Button
						id="rescan"
						type="primary"
						icon={firstScan ? "play-circle" : "redo"}
						onClick={() => rescanClick(scanSettingsId, rescanEnabled)}
						disabled={scanSettings === undefined || initialDisableRescan || !rescanEnabled || (!isAllowed.length && !isTrialAccount)}
						>
						{firstScan ? "SCAN" : "RESCAN"}
					</Button>
				:
					<ScanParametersModal 
					scanCreateDataSuccess={data}
					setModalLoading={setModalLoading}
					scanSettingsId={scanSettingsId}
					scanSettings={scanSettings} 
					setOpenModal={setParametersModalVisible} 
					openModal={isParametersModalVisible} 
					error={error && error.response && error.response.data && error.response.data.Errors}
					onRun={(e, baseAddress, uRemediateProfile) => rescanClick(scanSettingsId, rescanEnabled, baseAddress, uRemediateProfile)}>
							<Button
							loading={isModalLoading}
							id="rescan"
							type="primary"
							icon="redo"
							onClick={() => setParametersModalVisible({isVisible: true, id: scanSettingsId})}
							disabled={initialDisableRescan || !rescanEnabled || !isAllowed.length}
							>
								RESCAN
							</Button>
					</ScanParametersModal>
			}
		</StyledScanSettingsTop>
	)
}

export default ScansTop
